import React from 'react';
import SignInMFARouteV2 from './V2/SignInMFARouteV2';

const AgentSignInMFARouteV2: React.FC = () => {
  return <SignInMFARouteV2 />;
};

export default AgentSignInMFARouteV2;
